export enum CommunicationType {
  NullaOsta = '4',
}
